import { Entity } from '@debbie/common/dist/index.js';
import { InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { sortBy } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Loading from '../Loading.js';
import Timestamp from '../Timestamp.js';
import Email from './Email.js';
import { findRelevantEmails } from './thread-utils.js';
const EmailWithThread = (props) => {
    const lang = useSelector((s) => s.lang);
    const interactions = useInteractionsByReference(Entity.Case, props.caseId, true);
    if (!h.hasData(interactions) || interactions.data == null) {
        return React.createElement(Loading, null);
    }
    const emails = sortBy(interactions.data.filter((inter) => inter.type === InteractionType.Email), (inter) => new Date(inter.createdAt).getTime());
    const mainEmail = emails.find((inter) => inter.id === props.referenceInteraction);
    if (mainEmail == null) {
        return null;
    }
    // Assign synthetic imapId to pending emails so the matching algorithm incorporates them
    for (const email of emails) {
        if (email.state === OutgoingState.PENDING && !email.details.imapId) {
            email.details.imapId = `<${email.id}@synthetic.local>`;
        }
    }
    const relevantEmails = findRelevantEmails(emails, mainEmail);
    relevantEmails.reverse();
    return (React.createElement(Wrapper, null, relevantEmails.map((email) => {
        const isMainEmail = email.id === props.referenceInteraction;
        return (React.createElement(EmailWrapper, { key: email.id, isMainEmail: isMainEmail },
            React.createElement(EmailHeader, null,
                React.createElement("span", null,
                    lang.interactions[email.direction],
                    " -",
                    ' ',
                    React.createElement(Timestamp, { date: email.createdAt }))),
            React.createElement(Email, { noToggle: props.noToggle, interaction: email })));
    })));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
const EmailWrapper = styled.div `
  ${(props) => props.isMainEmail &&
    `
    border-left: 4px solid ${THEME.COLOR_PRIMARY};
    padding-left: 0.5em;
  `}
`;
const EmailHeader = styled.div `
  font-size: 0.85em;
  color: ${THEME.COLOR_GREY};
  padding: 0.5em 0;
`;
export default EmailWithThread;
//# sourceMappingURL=EmailWithThread.js.map